<template>
  <Modal id="materials-edit" #default="{ close }" @open="setMaterial">
    <div class="materials-edit-title">{{ $t('ModalMaterialsEdit.title') }}</div>
    <textarea
      v-model="name"
      ref="textarea"
      rows="1"
    />
    <select v-model="folder">
      <option :value="null">{{$t('pages.libs.materials.no-folders')}}</option>
      <option :value="folder.id" v-for="folder in folders" :key="folder.id">{{ folder.name }}</option>
    </select>

<!--    <NewSelect v-model="folder" :options="folders" label-by="name" value-by="id" is-multiple>
      <option :value="null">{{$t('pages.libs.materials.no-folders')}}</option>
      <option :value="folder.id" v-for="folder in folders" :key="folder.id">{{ folder.name }}</option>
    </NewSelect>-->
    <div class="actions">
      <button class="primary border" @click="save">
        {{ $t('save') }}
      </button>
      <button class="border" @click="close">{{ $t('cancel') }}</button>
    </div>
  </Modal>
</template>

<script>
import Modal from '@/components/modals/Modal'
import InputFile from '@/components/form/InputFile'
import FileList from '@/components/form/FileList'
import { mapActions, mapMutations, mapState } from 'vuex'
import getEvents from '../../mixins/getEvents'
import eventUtils from '@/mixins/eventUtils'
import handleErrorWithToast from '@/utils/handleErrorWithToast'
import NewSelect from '@/components/NewSelect.vue'

export default {
  name: 'ModalMaterialsEdit',
  components: { NewSelect, FileList, InputFile, Modal },
  mixins: [getEvents, eventUtils],
  data: () => ({
    name: null,
    folder: null,
  }),
  computed: {
    material() {
      return this.modalOptions;
    },
    ...mapState(['modal', 'modalOptions']),
    ...mapState('folders', ['folders']),
  },
  methods: {
    save() {
      return this.updateLibrary({
        id: this.material.id,
        name: this.name,
        folder: [this.folder],
      }).then(this.closeModal, handleErrorWithToast)
    },
    setMaterial(material) {
      this.name = material.name;
      this.folder = material.folder?.[0]?.id;
      //this.folder = material.folder?.map((item) => item?.id);
    },
    ...mapActions('library', ['updateLibrary']),
    ...mapMutations(['closeModal']),
  },
}
</script>

<style lang="scss">
#modal-materials-edit {
  .content {
    width: 440px;
  }
  .materials-edit-title {
    margin-bottom: 20px;

    font-size: 24px;
    font-weight: 700;
    line-height: 27.84px;

    color: #353535;
  }

  input {
    margin-bottom: 7px;
  }

  textarea {
    -webkit-appearance: none;
    height: auto;
    min-height: 72px;
    resize: none;
    margin-bottom: 20px;
    padding: 9px 14px;

    @include mobile {
      min-height: 114px;
    }
  }

  select {
    height: 40px;
  }

  .actions {
    margin-top: 30px;
  }
}
</style>
